/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "Sign Out",
  size: 20
}

const SvgSignOut = ({ size, ...props }: Props) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <path d="M13.1 13.4l-.6-.6 2.78-2.8H8V9h7.28L12.5 6.2l.6-.58L17 9.5z" />
    <path d="M13 2H3v15h10v-1H4V3h9z" />
  </Svg>
)

SvgSignOut.defaultProps = defaultProps
export default SvgSignOut
